import React, { useState, useEffect } from 'react';
import { getCartItems } from '../dbOperations';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

function Cart({ customerId }) {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (customerId) {
      console.log('Fetching cart items for customer:', customerId);
      getCartItems(customerId)
        .then(items => {
          console.log('Retrieved cart items:', items);
          setCartItems(items);
          setLoading(false);
        })
        .catch(err => {
          console.error('Failed to fetch cart items:', err);
          setError('Failed to fetch cart items');
          setLoading(false);
        });
    }
  }, [customerId]);

  const downloadImagesAsZip = async () => {
    const zip = new JSZip();
    const imgFolder = zip.folder('images');

    cartItems.forEach((item) => {
      if (item.petPerson && item.petPerson.images) {
        item.petPerson.images.forEach((image, index) => {
          const base64Data = image.startsWith('data:') ? image.split(',')[1] : image;
          imgFolder.file(`${item.productType}_${item.id}_${index}.jpg`, base64Data, { base64: true });
        });
      }
    });

    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, 'cart_images.zip');
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h2>Your Cart</h2>
      {cartItems.length === 0 && <p>No items in the cart.</p>}
      {cartItems.map((item) => (
        <div key={item.id}>
          <h3>{item.productType}</h3>
          <p>Customization: {item.customizationInfo}</p>
          <p>Pet/Person: {item.petPerson ? item.petPerson.name : 'N/A'}</p>
          {item.petPerson &&
            item.petPerson.images &&
            item.petPerson.images.map((image, index) => (
              <img
                key={index}
                src={image.startsWith('data:') ? image : `data:image/jpeg;base64,${image}`}
                alt={`Pet/Person ${index}`}
                style={{ maxWidth: '100px', maxHeight: '100px', margin: '10px' }}
                onError={(e) => {
                  console.error(`Error loading image ${index}:`, e);
                  e.target.src = 'https://via.placeholder.com/100?text=Error+Loading+Image';
                }}
              />
            ))}
        </div>
      ))}
      {cartItems.length > 0 && (
        <button onClick={downloadImagesAsZip}>Download All Images as ZIP</button>
      )}
    </div>
  );
}

export default Cart;